// eslint-disable-next-line import/prefer-default-export
export const TechStackStyles = {
  Java: {background: '#007396', color: '#FFFFFF'},
  Python: {background: '#3776AB', color: '#FFFFFF'},
  PHP: {background: '#777BB4', color: '#FFFFFF'},
  'C++': {background: '#00599C', color: '#FFFFFF'},
  'C#': {background: '#9B4F96', color: '#FFFFFF'},
  Go: {background: '#00ADD8', color: '#FFFFFF'},
  Ruby: {background: '#CC342D', color: '#FFFFFF'},
  Rust: {background: '#000000', color: '#FFFFFF'},
  Kotlin: {background: '#7F52FF', color: '#FFFFFF'},
  HTML: {background: '#E34F26', color: '#FFFFFF'},
  CSS: {background: '#1572B6', color: '#FFFFFF'},
  Dart: {background: '#0175C2', color: '#FFFFFF'},
  'Objective-C': {background: '#438EFF', color: '#FFFFFF'},
  SQL: {background: '#4479A1', color: '#FFFFFF'},
  JavaScript: {background: '#F7DF1E', color: '#000000'},
  TypeScript: {background: '#3178C6', color: '#FFFFFF'},
  React: {background: '#61DAFB', color: '#20232A'},
  Vue: {background: '#42B883', color: '#FFFFFF'},
  Angular: {background: '#DD0031', color: '#FFFFFF'},
  Svelte: {background: '#FF3E00', color: '#FFFFFF'},
  'Next.js': {background: '#000000', color: '#FFFFFF'},
  'Nuxt.js': {background: '#00C58E', color: '#FFFFFF'},
  Gatsby: {background: '#663399', color: '#FFFFFF'},
  'Alpine.js': {background: '#8BC0D0', color: '#1D1D1D'},
  'Spring Boot': {background: '#6DB33F', color: '#FFFFFF'},
  'Express.js': {background: '#000000', color: '#FFFFFF'},
  Fastify: {background: '#000000', color: '#FFFFFF'},
  Koa: {background: '#333333', color: '#FFFFFF'},
  Micronaut: {background: '#0B0C0C', color: '#FFFFFF'},
  Quarkus: {background: '#4695EB', color: '#FFFFFF'},
  'Ruby on Rails': {background: '#CC0000', color: '#FFFFFF'},
  'ASP.NET Core': {background: '#512BD4', color: '#FFFFFF'},
  Scala: {background: '#DC322F', color: '#FFFFFF'},
  Elixir: {background: '#4B275F', color: '#FFFFFF'},
  PostgreSQL: {background: '#336791', color: '#FFFFFF'},
  MySQL: {background: '#4479A1', color: '#FFFFFF'},
  MariaDB: {background: '#003545', color: '#FFFFFF'},
  'Microsoft SQL Server': {background: '#CC2927', color: '#FFFFFF'},
  'Oracle DB': {background: '#F80000', color: '#FFFFFF'},
  MongoDB: {background: '#47A248', color: '#FFFFFF'},
  CouchDB: {background: '#E42528', color: '#FFFFFF'},
  Redis: {background: '#DC382D', color: '#FFFFFF'},
  DynamoDB: {background: '#4053D6', color: '#FFFFFF'},
  Cassandra: {background: '#1287B1', color: '#FFFFFF'},
  'GitHub Actions': {background: '#2088FF', color: '#FFFFFF'},
  Vercel: {background: '#000000', color: '#FFFFFF'},
  Netlify: {background: '#00C7B7', color: '#FFFFFF'},
  Jenkins: {background: '#D24939', color: '#FFFFFF'},
  Azure: {background: '#0078D4', color: '#FFFFFF'},
  AWS: {background: '#FF9900', color: '#232F3E'},
  'Google Cloud': {background: '#4285F4', color: '#FFFFFF'},
  Docker: {background: '#2496ED', color: '#FFFFFF'},
  Kubernetes: {background: '#326CE5', color: '#FFFFFF'},
  Ansible: {background: '#000000', color: '#FFFFFF'},
  Terraform: {background: '#623CE4', color: '#FFFFFF'},
  Firebase: {background: '#FFA000', color: '#000000'},
  Swift: {background: '#FA7343', color: '#FFFFFF'},
  'Node.js': {background: '#393', color: '#ffffff'},
  FastAPI: {background: '#05998B', color: '#ffffff'},
  GraphQL: {background: '#E10098', color: '#ffffff'},
  Django: {background: '#092E20', color: '#ffffff'},
  Flask: {background: '#000000', color: '#ffffff'},
  Kafka: {background: '#231F20', color: '#ffffff'},
  GPT: {background: '#10A37F', color: '#ffffff'},
  Claude: {background: '#4B2AAD', color: '#ffffff'},
  Gemini: {background: '#001BFF', color: '#ffffff'},
  LLaMA: {background: '#FFD21F', color: '#000000'},
};
